let getQueryString = function (name, search) {
    var search = search ||  window.location.search.substr(1)
    let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    let r = search.match(reg);
    if (r != null) return  unescape(r[2]); return null;
}
export default getQueryString



// WEBPACK FOOTER //
// ./src/utils/get.query.js